import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M90.936,90.727,67.809,67.6A35.6,35.6,0,1,0,63.7,70.748L87.306,94.356a2.566,2.566,0,1,0,3.63-3.629Zm-77.49-49.99a30.712,30.712,0,1,1,30.711,30.71A30.747,30.747,0,0,1,13.446,40.737Z'

const IconSearch: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconSearch
